import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export type Theme = "light" | "dark";

/**
 * Theme.
 *
 * The key matches the one index.html reads in its pre-paint script; changing it
 * here without changing it there reintroduces the light-mode flash on reload.
 */
export const THEME_STORAGE_KEY = "gt-docs-theme";

const systemPrefersDark = (): boolean =>
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-color-scheme: dark)").matches;

export const themeAtom = atomWithStorage<Theme>(
  THEME_STORAGE_KEY,
  systemPrefersDark() ? "dark" : "light",
);

/**
 * Selected environment for the snippet panel.
 *
 * Snippets are generated once against the production host; switching
 * environments rewrites the hostname in the highlighted tokens. Keeping this in
 * one place means the choice persists across pages, which is what someone
 * working through an integration against UAT actually wants.
 */
export const ENV_STORAGE_KEY = "gt-docs-env";
export const envAtom = atomWithStorage<string>(ENV_STORAGE_KEY, "prod");

/** Chosen snippet language, persisted so it survives navigation. */
export const LANGUAGE_STORAGE_KEY = "gt-docs-language";
export const languageAtom = atomWithStorage<string>(
  LANGUAGE_STORAGE_KEY,
  "curl",
);

/** Command palette visibility. */
export const searchOpenAtom = atom(false);

/** Mobile navigation drawer visibility. */
export const mobileNavOpenAtom = atom(false);
